import React from "react";
import Sidebar from "../../common/Sidebar2nd/Sidebar";
import Active from "../../assets/img/Active.png";
import Image from "../../assets/img/Image.png";
import Image1 from "../../assets/img/Image1.png";
import cake from "../../assets/img/cake.png";
import speaker from "../../assets/img/speaker.png";
import mic from "../../assets/speaker.png";
import volume from "../../assets/img/volume.png";
import Aroplane from "../../assets/img/Aroplane.png";
import CD from "../../assets/img/CD.png";
import Ellipses3 from "../../assets/img/Ellipse 3.png";
import Ellipse4 from "../../assets/img/Ellipse4.png";
import Ellipse5 from "../../assets/img/Ellipse5.png";
import check_circle from "../../assets/img/check_circle.png";
import corner from "../../assets/img/corner-up-right.png";
import thumbs from "../../assets/img/thumbs-up.png";
import Frame2 from "../../assets/img/FramePerson1.png";
import Frame3 from "../../assets/img/FramePerson2.png";
import Frame4 from "../../assets/img/FramePerson3.png";
import Music from "../../assets/img/music.png";
import time from "../../assets/img/time.png";
import pino from "../../assets/img/pino.png";
import guttar from "../../assets/img/guttar.png";
import baja from "../../assets/img/baja.png";
import { NavLink } from "react-router-dom";
import { StateContext } from "../../store/StateProvider";

import HandShake from "../../assets/img/HandShake.png";
import "./Submision.css";
const Index = () => {
  const [state, dispatch] = StateContext();
  return (
    <section id="entry-name" className="entry-name">
      <div className="container-fluid">
        <div className="row">
          <Sidebar />
          <div className="col-11 max-width mx-auto marginTop10">
            <div className="row">
              <NavLink to={`/creator`} className="BackBtn">
                <i className="fa fa-angle-left" aria-hidden="true"></i>
                <span className="BackTxt">Back</span>
              </NavLink>
              {/* <!-- Start One side content --> */}
              <div className="col-md-7 mt-5 pt-md-4">
                {/* <!-- start navbar section --> */}
                <div className="row">
                  <div className="col-xl-4 col-md-6 text-capitalize my-2">
                    <div className="entry-name-text-">entry name</div>
                  </div>
                  <div className="col-md-6 align-self-center my-2 ms-xl-5">
                    <NavLink
                      to={`/Submission`}
                      className="entry-button1- p-2 px-3 mx-1"
                    >
                      version 2
                    </NavLink>
                    {/* <a href="/">version 2</a> */}
                    <NavLink to="" className="entry-button2- p-2 px-3 mx-1">
                      version 1
                    </NavLink>
                    <NavLink to="" className="entry-button2- p-2 px-3 mx-1">
                      version 0
                    </NavLink>
                  </div>
                </div>
                {/* <!-- start image button section --> */}
                <div className="row my-4">
                  <div className="col-md-11">
                    <div className="imageWrapper-">
                      <img src={Active} alt="logo" />
                    </div>
                  </div>
                </div>
                {/* <!--start Music image section --> */}
                <div className="row my-5">
                  <NavLink to="" className="col-2">
                    <img
                      src={state.items.play_circle_filled}
                      alt="play button"
                      className="img-fluid d-flex align-items-center mt-sm-1 mt-lg-3"
                    />
                  </NavLink>
                  <div className="col-9">
                    <div className="">
                      <img
                        src={Music}
                        alt="play button"
                        className="image-music-"
                      />
                    </div>
                  </div>
                </div>
                {/* <!-- start Rakesh section--> */}
                <div className="row">
                  <div className="col-2 col-lg-1 my-3">
                    <img src={Image} alt="" />
                  </div>
                  <div className="col-4 mx-5 my-3">
                    <h6 className="person-data1- mb-0">Rakesh Kar</h6>
                    <p className="person-data2- mb-0">@rakesh_eth0</p>
                    <span className="person-data3- mb-0">Moderator</span>
                  </div>
                </div>
                {/* <!-- start user box --> */}
                <div className="row pt-5 pb-2 mx-1">
                  <div className="col-12 p-2">
                    <div className="row BoxShare py-2">
                      <div className="col-1">
                        <img src={Image1} alt="" />
                      </div>
                      <div className="col-4 align-self-center ps-4">
                        <NavLink to="" className="ShareThrough">
                          Share your Thoughts
                        </NavLink>
                      </div>
                      <div className="col-7 align-self-center">
                        <button
                          type="submit"
                          className="SubmitBtn1- float-end py-2"
                        >
                          Send
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!-- user check box --> */}
                <div className="row">
                  <div className="col-12">
                    <div className="form-check">
                      <input
                        className="form-check-input form-check-box-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <label
                        className="form-check-label form-text- ms-3"
                        for="flexCheckDefault"
                      >
                        Submit @ 0:42 Timestamp?
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row pt-5">
                  <div className="col-md-6">
                    <h3 className="bounties-text-">Bounties</h3>
                  </div>
                  <div className="col-md-6">
                    <button type="submit" className="SubmitBtn2- float-end">
                      Submit
                    </button>
                  </div>
                </div>
                <div className="row">
                  <div className="col form-text2- my-3">Primary</div>
                  {/* <!-- check boxes row one --> */}
                  <div className="col-12 d-flex flex-wrap my-2">
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={mic} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Vocalist: 10%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={cake} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Static Graphics: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={speaker} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Rapper: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={volume} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Bass: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                  </div>
                  {/* <!-- end of check boxes row one --> */}
                  {/* <!-- check boxes row Two --> */}
                  <div className="col-12 mt-4 d-flex flex-wrap my-2">
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={time} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Drum: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={pino} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Keys/Synth: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={guttar} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Guitar/Strings: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                  </div>
                  {/* <!-- end of check boxes row Two --> */}
                  {/* <!-- check boxes row three --> */}
                  <div className="col-12 mt-4 d-flex flex-wrap my-2">
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={baja} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Horns/Woodwind: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={CD} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Turntablism: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img
                        src={HandShake}
                        alt="mic"
                        className="ms-2 img-fluid"
                      />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Motion Graphics: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                  </div>
                  {/* <!-- end of check boxes row three --> */}
                </div>
                {/* <!-- Secondary check boxes --> */}
                <div className="row">
                  <div className="col form-text2- my-3">Secondary</div>
                  {/* <!-- check boxes row three --> */}
                  <div className="col-12 d-flex flex-wrap my-2">
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img
                        src={Aroplane}
                        alt="mic"
                        className="ms-2 img-fluid"
                      />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Mixing: 3%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <input
                        className="form-check-input form-check-box2-"
                        type="checkbox"
                        value=""
                        id="flexCheckDefault"
                      />
                      <img src={CD} alt="mic" className="ms-2 img-fluid" />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        Mastering: 4.5%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                  </div>
                  {/* <!-- end of check boxes row three --> */}
                </div>
                {/* <!-- start section of images and text --> */}
                <div className="row pt-3">
                  <div className="col-12">
                    <h3 className="bounties-text-">Current Creator Split</h3>
                  </div>
                  {/* <!-- check boxes row three --> */}
                  <div className="col-12 mt-4 d-flex flex-wrap my-2">
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <img
                        src={Ellipses3}
                        alt="mic"
                        className="me-2 img-fluid"
                      />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        wavthe0ry.eth: 42.5%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <img
                        src={Ellipse4}
                        alt="mic"
                        className="me-2 img-fluid"
                      />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        reshhe0ry.eth: 4.5%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                    {/* <!-- single check box --> */}
                    <div className="form-check me-4">
                      <img
                        src={Ellipse5}
                        alt="mic"
                        className="me-2 img-fluid"
                      />
                      <label
                        className="form-check-label ms-1 form-text3-"
                        for="flexCheckDefault"
                      >
                        rjoyery.eth: 53%
                      </label>
                    </div>
                    {/* <!-- single check box --> */}
                  </div>
                  {/* <!-- end of check boxes row three --> */}
                </div>
                {/* <!-- start last button --> */}
                <div className="row">
                  <div className="col-12 mt-4 mb-5 pb-5">
                    <button type="submit" className="SubmitBtn3-">
                      Burn WavPool Token for 2.5% Split
                    </button>
                  </div>
                </div>
              </div>
              {/* <!-- Start second side content --> */}
              <div className="col-md-5 half-wrapper- ps-5">
                {/* <!-- set comment and select box --> */}
                <div className="row comments-text-">
                  <div className="col-7 align-self-center">Comments</div>
                  <div className="col-5 SelectboxWrapper">
                    <select name="" id="" className=" Selectbox">
                      <option value="1">Open</option>
                      <option value="1">Completed</option>
                    </select>
                  </div>
                </div>
                {/* <!-- Single comment box start --> */}
                <div className="row pt-3">
                  <div className="col-12">
                    <div className="row justify-content-between my-2">
                      <div className="col-xxl-7">
                        <img src={Frame2} alt="" className="img-fluid me-2" />
                        <span className="MaudeTxt">Maude Hall</span>
                        <img src={check_circle} alt="" />
                        <span className="comments-text-">14 min</span>
                      </div>
                      <div className="col-xxl-5 my-3">
                        <NavLink to="" className="entry-button3- p-2 px-3 mx-1">
                          Mark Complete
                        </NavLink>
                        <NavLink to="" className="entry-button1- p-1 px-3 mx-1">
                          version2
                        </NavLink>
                      </div>
                      <div className="col-12 pt-2">
                        <p className="paragraph-text- ps-3 pt-3 pe-5">
                          That's a fantastic new app feature. You and Your team
                          did an excelent job of incorporating user test
                          feedback.
                        </p>
                      </div>
                      <div className="col-11 d-flex justify-content-between paragraph-icon-text- px-4">
                        <div>
                          <span>2 Likes </span>
                          <img src={corner} alt="" className="pointer" />
                          <span className="pointer">Reply</span>
                        </div>
                        <div>
                          <NavLink to="">
                            <img src={thumbs} alt="" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--end of Single comment box start --> */}
                {/* <!-- Single comment box start --> */}
                <div className="row pt-3 ms-2">
                  <div className="col-12">
                    <div className="row justify-content-between my-2">
                      <div className="col-xxl-7">
                        <img src={Frame3} alt="" className="img-fluid me-2" />
                        <span className="MaudeTxt">Dianne Russell</span>

                        <span className="comments-text-">24 min</span>
                      </div>
                      <div className="col-xxl-5 my-3">
                        <NavLink to="" className="entry-button3- p-2 px-3 mx-1">
                          Mark Complete
                        </NavLink>
                        <NavLink to="" className="entry-button2- p-1 px-3 mx-1">
                          version1
                        </NavLink>
                      </div>
                      <div className="col-12 pt-2">
                        <p className="paragraph-text- ps-3 pt-3 pe-5">
                          But don't you think the timing of becuase many other
                          app have done this even earlier, cuasing people to
                          switch app?
                        </p>
                      </div>
                      <div className="col-11 d-flex justify-content-between paragraph-icon-text- px-4">
                        <div>
                          <span>1 Like </span>
                          <img src={corner} alt="" className="pointer" />
                          <span className="pointer">Reply</span>
                        </div>
                        <div>
                          <NavLink to="">
                            <img src={thumbs} alt="" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <!--end of Single comment box start --> */}
                {/* <!-- Single comment box start --> */}
                <div className="row pt-3 ms-4">
                  <div className="col-12 mx-auto">
                    <div className="row justify-content-between my-2">
                      <div className="col-xxl-7">
                        <img src={Frame4} alt="" className="img-fluid me-2" />
                        <span className="MaudeTxt">Esther Howard</span>

                        <span className="comments-text-">26 min</span>
                      </div>
                      <div className="col-xxl-5 my-3">
                        <NavLink to="" className="entry-button3- p-2 px-3 mx-1">
                          Mark Complete
                        </NavLink>
                        <NavLink to="" className="entry-button1- p-1 px-3 mx-1">
                          version2
                        </NavLink>
                      </div>
                      <div className="col-12 pt-2">
                        <p className="paragraph-text- ps-3 pt-3 pe-5">
                          This could be due to them talking their time to
                          release a stable version.
                        </p>
                      </div>
                      <div className="col-11 d-flex justify-content-between paragraph-icon-text- px-4">
                        <div>
                          <span>12 likes </span>
                          <img src={corner} alt="" className="pointer" />
                          <span className="pointer">Reply</span>
                        </div>
                        <div>
                          <NavLink to="">
                            <img src={thumbs} alt="" />
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <!-- End second side content --> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Index;
